
import Vue from 'vue';
import Component from 'vue-class-component';

import { Prop, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import FeedbackCard from './feedbackCard.vue';
import TransferCard from './transferCard.vue';
import { __DEV__ } from '@/params/config';

@Component({ components: { FeedbackCard,TransferCard } })
export default class FeedbackHome extends Vue {
  // $refs: {
  //   [key: string]: any;
  //   validate: HTMLFormElement;
  // };

  @Prop() noSearch: boolean;
  @Prop() keyword: string;

  @Getter feedbackList: any;
  @Getter allproductSubsystemList: any;
  @Getter assignee: any;
  @Getter defaultAssignee: any;
  @Getter addAssignee: any;
  @Getter assigneePermission: any;
  @Getter defaultAssigneeByModule: any;
  


  @Action getAssigneePermission: Function;
  @Action getFeedbackList: Function;
  @Action getAllProductSubsystemList: Function;
  @Action getAssignee: Function;
  @Action('getDefaultAssigneeByModule') getDefaultAssigneeByModule: Function;
  @Action getDefaultAssignee: Function;
  @Action addDefaultAssignee: Function;
  @Action saveDefaultAssigneeByModule: Function;

  activeIndex: any = '1'; //
  AssigneeGUID: string = '';
  idList: any = [];
  isABUList: any = [];
  newAssignee: any = [];
  AssigneeDisplayName: string = '';
  searchKey: string = ''; // 搜索关键字
  totalFeedbackList: number = 0; // 反馈信息统计数目
  currentPage: number = 1; // 当前页码  
  pageSize: number = 10; // 每页显示条数
  dialogVisible: boolean = false;
  moduledialogVisible: boolean = false;
  statuskeyWord:'1'; // 状态关键字,默认是1
  tabPosition:'1';
  url:string='https://yxmgl.mingyuanyun.com/requirementManage/feedbackManage';// PROCESS正式环境
  created() {
    this.activeIndex = this.$route.query.activeIndex || '1'
    this.getAssigneePermission();
    this.getFeedbackInfo();
    this.getAllProductSubsystemList();
    this.getAssignee();    
    this.getDefaultAssignee();

    this.tabPosition='1'; //状态关键字,默认是1    
    if(process.env.NODE_ENV=='development'||process.env.NODE_ENV=='test'){
      // PROCESS测试环境
      this.url="https://process-test.myscrm.cn/online-jira/demand-or-defect";
    }
  }
  go(){
    window.open(this.url);        
  }

  goHistory(){
    window.open(`${location.href}/list`);
  }

  // mounted() {}
  get watchObj() {
    const { allproductSubsystemList, defaultAssignee } = this;

    return { allproductSubsystemList, defaultAssignee };
  }
  // 切换分类页签
  handleSelect(key: string) {
    this.activeIndex = key;
    this.searchKey = '';
    this.currentPage = 1;
    this.statuskeyWord = this.tabPosition;
    this.getFeedbackInfo();
    // this.$router.replace({path:'/feedback',query:{activeIndex:key}})
  }

  // pageSize 每页显示条数发生改变
  handleSizeChange(val: number) {
    this.pageSize = val;
    this.getFeedbackInfo();
  }
  // currentPage 当前页码发生改变
  handleCurrentChange(val: number) {
    this.currentPage = val;    
    this.getFeedbackInfo();
  }

  // 搜索
  handleClickSearch() {
    // 如果是搜索 当前页数重置为1
    this.currentPage=1;
    this.getFeedbackInfo();
  }

  // 获取首页数据信息
  getFeedbackInfo() {
    this.getFeedbackList({
      PageSign: Number(this.activeIndex),
      Keyword: this.searchKey,
      PageIndex: this.currentPage,
      PageSize: this.pageSize,
      StatusKeyWord:this.statuskeyWord   
    });
  }

  // 根据转单状态进行查询
  selectStatus(){     
      this.statuskeyWord=this.tabPosition; 
      this.getFeedbackList({
      PageSign: 4,
      Keyword: this.searchKey,
      PageIndex: this.currentPage,
      PageSize: this.pageSize,
      StatusKeyWord:this.tabPosition
    });
  }

  filterSubsystem(scope: any) {
    let name = '';
    this.allproductSubsystemList.data.map((item: any) => {
      if (item.SubSystemGUID === scope.row.SubSystemGUID) {
        name = item.SubSystemName;
      }
    });

    return name;
  }

  toFeedbackSetting() {
    this.dialogVisible = !this.dialogVisible;
  }
  onCancel() {
    this.dialogVisible = !this.dialogVisible;
  }

  moduletoFeedbackSetting(row:any) {
      this.getDefaultAssigneeByModule({        
        subSystemName: row.name
      });
    this.moduledialogVisible = !this.moduledialogVisible;
  }
  moduleonCancel() {
    this.moduledialogVisible = !this.moduledialogVisible;
  }
  noduleonClose(){

  }

  onClose() {
    setTimeout(() => {
      this.getDefaultAssignee();
    }, 500);
  }
  onSubmit() {
    let valid = true;
    this.newAssignee.map((item: any, index: number) => {
      if (!!this.idList[index] && this.isABUList[index] !== undefined) {
        this.newAssignee[index].JiraUserId = parseInt(this.idList[index], 10);
        this.newAssignee[index].IsHandleByProject = this.isABUList[index];
      } else {
        valid = false;
      }
    });
    if (valid) {
      this.addDefaultAssignee({ FeedbackAssignee: this.newAssignee }).then(
        () => {
          this.$message.success('保存成功');
          this.dialogVisible = false;
        }
      );
    } else {
      this.$message.warning('还有选项没选哦！');
    }
  }
 
   moduleonSubmit() {
    let valid = true;
    let data=this.defaultAssigneeByModule.data;
      this.saveDefaultAssigneeByModule({ FeedbackAssigneeByModule: data }).then(
        () => {
          this.$message.success('保存成功');
          this.moduledialogVisible = false;
        }
      );

  }

  @Watch('watchObj', { immediate: true, deep: true })
  private changeObj(obj: any) {    
    obj.allproductSubsystemList.data.map((item: any, index: any) => {
      this.newAssignee[index] = {
        name: item.SubSystemName,
        SubSystemGUID: item.SubSystemGUID,
        JiraUserId: null,
        IsHandleByProject: false
      };
      this.idList[index] = '';
      this.isABUList[index] = false;
      obj.defaultAssignee.data.map((assignee: any) => {
        if (assignee.SubSystemGuid === item.SubSystemGUID) {
          this.idList[index] = assignee.JiraUserId.toString();
          this.isABUList[index] = assignee.IsHandleByProject || false;
        }
      });
    });
  }
}
